module.exports = __webpack_public_path__ + "img/25.e5cb6442.png";